import { Button, NonIdealState } from "@blueprintjs/core";
import React, { ReactNode } from "react";
import { ErrorBoundary, FallbackProps } from "react-error-boundary";

const ErrorFallback = ({ error }: FallbackProps) => {
  return (
    <NonIdealState
      icon="error"
      title="Error"
      description={error.message}
      action={<Button onClick={() => window.location.reload()}>Reload</Button>}
    />
  );
};

export interface ErrorWrapperProps {
  children: ReactNode;
}

export const ErrorWrapper = ({ children }: ErrorWrapperProps) => {
  return <ErrorBoundary FallbackComponent={ErrorFallback}>{children}</ErrorBoundary>;
};
